import { useRef } from 'react';
import { observer } from 'mobx-react-lite';

import Radar from '@cutwise/radar-chart';
import { useMount } from '@cutwise/utils';

import { useStore } from '@/stores/StoreProvider';

import { COMMON_FIELDS } from './CommonParameters.constants';
import styles from './CommonParameters.module.scss';

function CommonParameters() {
  const { diamond } = useStore('diamondsStore');

  const radarRef = useRef<Nullable<SVGSVGElement>>(null);

  function getChartData() {
    return (diamond ? [diamond] : []).map((diamond) =>
      COMMON_FIELDS.map((field) => ({
        axis: field.key,
        value: field.getterValue(diamond) || '',
        label: field.getter(diamond) || '',
      })),
    );
  }

  useMount(() => {
    new Radar(
      radarRef.current as SVGSVGElement,
      COMMON_FIELDS.map((field) => ({
        code: field.key,
        label: field.fullLabel,
        range: [0, 1],
      })),
      ['#F1B072', 'white'],
    ).draw(getChartData());
  });

  return (
    <div className={styles.root}>
      <div className="container">
        <h2>Common parameters</h2>

        <svg className={styles.svg} ref={radarRef} preserveAspectRatio="xMidYMid meet" viewBox="0 0 1000 1000" />
      </div>
    </div>
  );
}

export default observer(CommonParameters);
